<template>

  <CreditoView />

</template>

<script>
import CreditoView from '../components/ask/pages/CreditoView.vue'

export default {
  pageName: 'CreditoView',
  components: {
    CreditoView

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
